import weakset from 'weakset'

import map from 'es6-map'

if (typeof window.WeakSet === 'undefined') {
  window.WeakSet = weakset
}

if (typeof window.Map === 'undefined') {
  window.Map = map
}

export default {}
